
import { defineComponent, reactive, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  ChangeLogService,
  ChangeRecordItem
} from '@/views/dashboard/group/client/terminal-info/change-log/change-log.service'
import ContentAdaptLayout from '@/views/dashboard/_components/content-adapt-layout/content-adapt-layout.vue'

export default defineComponent({
  components: { ContentAdaptLayout },
  props: {
    deviceId: {
      type: String,
      default: ''
    }
  },

  setup (props, context) {
    const { t, locale } = useI18n()
    const injector = useReflectiveInjector([ChangeLogService])
    const service = injector.get(ChangeLogService)

    const isLoading = ref(false)

    const tableData = ref<ChangeRecordItem[]>([])
    const pagination = reactive({
      currentPage: 1,
      pageSize: 20,
      total: 0,
    })

    const changeTypeLabelMap = computed(() => {
      void locale.value
      return {
        1: t('groupClient.terminalInfoDetail.changeTypeCpu'),
        2: t('groupClient.terminalInfoDetail.changeTypeMemCapacity'),
        3: t('groupClient.terminalInfoDetail.changeTypeMemInfo'),
        4: t('groupClient.terminalInfoDetail.changeTypeDisk'),
        5: t('groupClient.terminalInfoDetail.changeTypeMainboard'),
        6: t('groupClient.terminalInfoDetail.changeTypeGpu'),
        7: t('groupClient.terminalInfoDetail.changeTypeNic'),
        8: t('groupClient.terminalInfoDetail.changeTypeAudio'),
        9: t('groupClient.terminalInfoDetail.changeTypeDisplay'),
      } as Record<number, string>
    })

    function updateData () {
      isLoading.value = true
      service.getChangeRecord({
        device_id: props.deviceId,
        page: pagination.currentPage,
        limit: pagination.pageSize
      }).then(response => {
        pagination.total = response.total
        tableData.value = response.list
      }).finally(() => {
        isLoading.value = false
      })
    }

    function handleSizeChange (size: number) {
      pagination.pageSize = size
      updateData()
    }

    function handleCurrentChange (page: number) {
      pagination.currentPage = page
      updateData()
    }

    updateData()

    return {
      changeTypeLabelMap,
      isLoading,
      tableData,
      pagination,
      handleSizeChange,
      handleCurrentChange,
    }
  }
})
